import React, { useEffect, useState } from "react"
import { Carousel } from "antd"
import { Link } from "react-router-dom"
import "../style/Banner.css" // CSS riêng để không dùng Tailwind

const slides = [
  {
    id: 1,
    src: "https://ewave-sim.com/wp-content/uploads/2024/08/banner-web-1_-co-text_mb-1400x788.png",
    link: "login",
  },
  {
    id: 2,
    src: "https://gohub.vn/wp-content/uploads/2025/02/1280X1280.png",
    // alt: "Chicago",
    link: "login",
  },
]

const Banner = () => {
  return (
    <div className="banner-container">
      <div className="banner-carousel">
        <Carousel autoplay>
          {slides.map(slide => (
            <Link key={slide.id} to={`/${slide.link}`}>
              <img
                src={slide.src}
                alt={slide.alt || "Banner"}
                className="banner-image"
              />
            </Link>
          ))}
        </Carousel>
      </div>
      <div className="banner-side">
        <img
          src="https://gohub.vn/wp-content/uploads/2024/01/Ads_eSIM_1200x628-1024x536.png"
          alt="k1"
          className="side-image"
        />
        <img
          src="https://vnpt.com.vn/Media/Images/24092024/esim-co-chuyen-vung-quoc-te-duoc-khong-vnpt.jpg"
          alt="k2"
          className="side-image"
        />
      </div>
    </div>
  )
}

export default Banner
